/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-webkit-box;display:flex}[_nghost-%COMP%]   .chat-bot-modal-iframe[_ngcontent-%COMP%]{padding:0;width:100%;max-height:calc(100vh - 130px);border-radius:16px 16px 0 16px;transition:height 1s ease-in-out;transition-delay:.5s}[_nghost-%COMP%]   .chat-bot-modal-iframe.chat-bot-modal-iframe--fast[_ngcontent-%COMP%]{transition:height .15s ease-out;transition-delay:0s}"];
export { styles as styles };
//# sourceMappingURL=chat-bot-iframe.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/components/chat-bot-iframe/chat-bot-iframe.component.scss.shim.ngstyle.js
// module id = 1354
// module chunks = 27 28 29